import React from 'react'
import styled from 'styled-components'
import { Link } from 'react-router-dom'
import { Menu, Sidebar, Icon } from 'semantic-ui-react'

import { connect } from 'react-redux'

import { toggleSidebar } from '../../actions/uiActions'
import { logOut } from '../../actions/authActions'

const DesktopComp = ({ sidebarVisible, toggleSidebar, className, logOut }) => {
    const activeItem = ''

    return (
        <div className={className}>

            <div className="full-menu">
                <Menu color="blue" inverted attached="bottom">
                    <Menu.Item active={activeItem === '/admin'} as={Link} to="/admin">
                        Ylläpito
                    </Menu.Item>

                    <Menu.Item active={activeItem === '/admin/asiakkaat'} as={Link} to="/admin/asiakkaat">
                        Asiakkaat
                    </Menu.Item>

                    <Menu.Item active={activeItem === '/admin/kohteet'} as={Link} to="/admin/kohteet">
                        Kohteet
                    </Menu.Item>

                    <Menu.Menu position='right'>
                        <Menu.Item onClick={logOut}>
                            Kirjaudu ulos
                        </Menu.Item>
                    </Menu.Menu>
                </Menu>
            </div>

            <div className="mobile-menu">
                <Menu color="blue" inverted attached="bottom">
                    <Menu.Item active={activeItem === '/admin'} as={Link} to="/admin">
                        Ylläpito
                    </Menu.Item>
                    <Menu.Menu position='right'>
                        <Menu.Item active={sidebarVisible} onClick={toggleSidebar} >
                            <Icon name='sidebar' />
                        </Menu.Item>
                    </Menu.Menu>
                </Menu>
            </div>

        </div>
    )
}

const Desktop = styled(DesktopComp) `
    & .mobile-menu{
        display: none;
    }
    @media(max-width: 600px){
        & .full-menu{
            display: none;
        }
        & .mobile-menu{
            display:block;
        }
    }
`

const Mobile = ({ sidebarVisible, toggleSidebar, logOut }) => {
    const activeItem = ''

    return (
        <Sidebar
            as={Menu}
            animation='overlay'
            width='thin'
            visible={sidebarVisible}
            icon='labeled'
            vertical
            inverted
        >

            <Menu.Item
                active={activeItem === '/admin'}
                as={Link} to="/admin"
                onClick={toggleSidebar}
            >
                <Icon name='home' />
                Ylläpito
            </Menu.Item>

            <Menu.Item
                active={activeItem === '/admin/asiakkaat'}
                as={Link} to="/admin/asiakkaat"
                onClick={toggleSidebar}
            >
                <Icon name='user outline' />
                Asiakkaat
            </Menu.Item>

            <Menu.Item
                active={activeItem === '/admin/kohteet'}
                as={Link} to="/admin/kohteet"
                onClick={toggleSidebar}
            >
                <Icon name='building outline' />
                Kohteet
            </Menu.Item>

            <Menu.Item
                onClick={() => { toggleSidebar(); logOut(); }}
            >
                <Icon name='log out' />
                Kirjaudu ulos
            </Menu.Item>

        </Sidebar>
    )
}

const mapStoP = state => {
    return {
        sidebarVisible: state.ui.sidebarVisible
    }
}

const mapDtoP = dispatch => {
    return {
        logOut: () => dispatch(logOut()),
        toggleSidebar: () => dispatch(toggleSidebar())
    }
}

const DesktopMenu = connect(mapStoP, mapDtoP)(Desktop)
const MobileMenu = connect(mapStoP, mapDtoP)(Mobile)

export { DesktopMenu, MobileMenu }




// WEBPACK FOOTER //
// ./src/Admin/Menu/Menu.js